const PROOFREAD_PROMPT_STORAGE_KEY = "editor_proofread_system_prompt";

export function readEditorProofreadPromptOverride(): string {
  try {
    return String(localStorage.getItem(PROOFREAD_PROMPT_STORAGE_KEY) ?? "").trim();
  } catch {
    return "";
  }
}

export function writeEditorProofreadPromptOverride(prompt: string): void {
  const next = String(prompt ?? "").trim();
  try {
    if (!next) {
      localStorage.removeItem(PROOFREAD_PROMPT_STORAGE_KEY);
      return;
    }
    localStorage.setItem(PROOFREAD_PROMPT_STORAGE_KEY, next);
  } catch {
  }
}

